import { Route } from 'react-router-dom';
import { lazyRoute } from '../lazyRoute';

// Two lazily loaded chunks with the screens and their nested routes (./integrations-section.tsx, ./developer-section.tsx)
const IntegrationsSection = lazyRoute(() => import('./integrations-section').then((m) => m.IntegrationsSection));
const DeveloperSection = lazyRoute(() => import('./developer-section').then((m) => m.DeveloperSection));
const ConsentPage = lazyRoute(() => import('./ConsentPage').then((m) => m.ConsentPage));

/** Integrations (sub-account), the developer portal and its marketplace settings (developer/marketplace), under /agencies/:agencyId */
export const integrationsAgencyRoutes = (
  <>
    <Route path="integrations/*" element={<IntegrationsSection />} />
    <Route path="developer/*" element={<DeveloperSection />} />
  </>
);

/** The OAuth consent screen (signed in; a branded public page, outside the agency shell) */
export const integrationsSignedInRoutes = <Route path="/oauth/consent" element={<ConsentPage />} />;
